<template>
  <div>
    <div class="loading-overlay" v-if="isLoading">
      <div class="spinner-border text-danger" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="fromParentBtn"
      :btnClass="'btn-primary'"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass" v-if="!app_type_reject">{{
      this.alertMessage
    }}</bs-msg-alert>
    <div class="position-relative pb-5">
      <div class="row mb-5">
        <ul class="nav nav-tabs nav-fill">
          <li class="nav-item">
            <button
              type="button"
              :class="tab_switch('application')"
              @click="tab_switch_action('application')"
            >
              <i class="bi bi-person-fill me-1"></i>申請情報
            </button>
          </li>
          <li
            class="nav-item"
            v-if="typeof (application_obj || {}).sales === 'object'"
          >
            <button
              type="button"
              :class="tab_switch('sales')"
              @click="tab_switch_action('sales')"
            >
              <i class="bi bi-list-check me-1"></i>決済情報
            </button>
          </li>
          <li
            class="nav-item"
            v-if="
              order_manage_disp &&
              typeof (application_obj || {}).sales === 'object'
            "
          >
            <button
              type="button"
              :class="tab_switch('status')"
              @click="tab_switch_action('status')"
            >
              <i class="bi bi-gear-fill me-1"></i>状態管理
            </button>
          </li>
        </ul>
      </div>
      <div :class="tabDisplay('status')">
        <h5>状態管理</h5>
        <div class="container">
          <div class="row mb-4" v-if="order_manage_disp">
            <div class="col-4 mb-2">
              <label for="LicenseNo" class="form-label">現在の申請状況</label>
              <bs-select
                :options="application_check_type_list"
                :nullOption="false"
                v-model="application_obj.application_check_type"
                :disabled="true"
              ></bs-select>
            </div>
            <div class="col-4 mb-2">
              <label for="LicenseNo" class="form-label">更新する申請状況</label>
              <bs-select
                :options="application_check_type_list"
                :nullOption="'更新する場合は選択して下さい'"
                v-model="force_update_application_check_type_value"
              ></bs-select>
              <!-- v-model="application_obj.application_check_type" -->
            </div>
            <div class="col-4 mb-2">
              <label for="LicenseNo" class="form-label">&nbsp;</label>
              <div class="d-grid">
                <button
                  @click="force_update_application_check_type"
                  class="btn btn-warning"
                  :disabled="
                    !force_update_application_check_type_value ? true : false
                  "
                >
                  更新する
                </button>
              </div>
            </div>
            <div class="col-4 offset-8 mb-2">
              <label for="LicenseNo" class="form-label">&nbsp;</label>
              <div class="d-grid">
                <button @click="update_cancel" class="btn btn-danger">
                  申請取消
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div :class="tabDisplay('sales')">
        <h5>決済情報</h5>
        <div class="container">
          <div class="row mb-4" v-if="order_manage_disp">
            <div>
              <div class="alert alert-warning">
                <p v-if="chk_sales_data_1" class="mb-2 pb-2 border-bottom">
                  <span class="d-block h5">二重決済の可能性</span>
                  決済データにコンビニ/クレジット双方の支払いデータが存在しています。
                </p>
                <p v-if="chk_sales_data_2" class="mb-2 pb-2 border-bottom">
                  <span class="d-block h5"
                    >決済済なのにステータスが支払い前の可能性</span
                  >
                  決済データが支払い済の可能性があるにもかかわらず、申請が支払い前になっています。
                </p>
                <!-- <p v-if="chk_sales_data_3" class="mb-2 pb-2 border-bottom">
                  <span class="d-block h5">二重決済の可能性</span>
                  決済データにコンビニ/クレジット双方の支払いデータが存在しています。
                </p>
                <p v-if="chk_sales_data_4" class="mb-2 pb-2 border-bottom">
                  <span class="d-block h5">二重決済の可能性</span>
                  決済データにコンビニ/クレジット双方の支払いデータが存在しています。
                </p>
                <p v-if="chk_sales_data_5" class="mb-2 pb-2 border-bottom">
                  <span class="d-block h5">二重決済の可能性</span>
                  決済データにコンビニ/クレジット双方の支払いデータが存在しています。
                </p> -->
              </div>
            </div>
          </div>
          <div class="row">
            <table class="table">
              <tbody>
                <tr>
                  <th style="width: 30%">注文番号</th>
                  <td style="width: 70%">
                    <input
                      type="text"
                      class="form-control-plaintext"
                      :value="(application_obj || {}).sales?.charge_order_id"
                    />
                  </td>
                </tr>
                <tr v-if="order_manage_disp">
                  <th>
                    <button
                      @click="
                        getGmoCheck(
                          (application_obj || {}).sales?.charge_order_id
                        )
                      "
                      class="btn btn-sm btn-light btn-outline-secondary"
                    >
                      GMOに照会
                    </button>
                  </th>
                  <td>
                    <div v-if="gmo_data_json">
                      <dl
                        :key="json_key"
                        v-for="json_key in Object.keys(gmo_data_json)"
                      >
                        <dt>{{ json_key }}</dt>
                        <dd>{{ gmo_data_json[json_key] }}</dd>
                      </dl>
                    </div>
                  </td>
                </tr>
                <tr v-if="(application_obj || {}).sales?.charge_type">
                  <th>注文種別</th>
                  <td>
                    <input
                      type="text"
                      class="form-control-plaintext"
                      :value="
                        (application_obj || {}).sales?.charge_type == 'CREDIT'
                          ? 'クレジットカード'
                          : 'コンビニ'
                      "
                    />
                  </td>
                </tr>
                <tr>
                  <th>請求金額</th>
                  <td>
                    <input
                      type="text"
                      class="form-control-plaintext"
                      :value="
                        number_format((application_obj || {}).sales?.amount)
                      "
                    />
                  </td>
                </tr>
                <tr>
                  <th>支払い金額</th>
                  <td>
                    <input
                      type="text"
                      class="form-control-plaintext"
                      :value="
                        number_format(
                          (application_obj || {}).sales?.payment_value
                        )
                      "
                    />
                  </td>
                </tr>
                <tr>
                  <th>コンビニ</th>
                  <td>
                    <input
                      type="text"
                      class="form-control-plaintext"
                      :value="(application_obj || {}).sales?.cash_konbini_code"
                    />
                  </td>
                </tr>
                <tr>
                  <th>お客様番号</th>
                  <td>
                    <input
                      type="text"
                      class="form-control-plaintext"
                      :value="
                        (application_obj || {}).sales?.cash_receipt_number
                      "
                    />
                  </td>
                </tr>
                <tr>
                  <th>確認番号</th>
                  <td>
                    <input
                      type="text"
                      class="form-control-plaintext"
                      :value="
                        (application_obj || {}).sales?.cash_confirmation_number
                      "
                    />
                  </td>
                </tr>
                <tr>
                  <th>支払い期限</th>
                  <td>
                    {{ (this.application_obj || {}).sales?.cash_re }}
                    <input
                      type="text"
                      class="form-control-plaintext"
                      :value="cash_konbini_expiry_date"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div :class="tabDisplay('application')">
        <AppFormView_1000
          v-if="app_type_1000"
          :app_data="application_obj"
          :regist_data="regist_obj"
          :app_check_cd="application_check_cd_obj[1000]"
          :app_check_type="application_check_type_obj"
          :sex_type_cd="sex_type_cd_obj"
          :license_no_stock="license_no_stock_obj"
          :pref_cd="pref_cd_obj"
          :member_document_cd="member_document_cd_obj"
          :circuit_list="circuit_obj"
          :draft_orders="draft_order_obj"
          @parentFuncEditStart="edit_start()"
          @parentFuncEditCancel="edit_cancel()"
          @parentFuncAppUpdate="update"
          @parentFuncAppUpdateCommunication="update_communication"
          @parentFuncCircuitChk="update_circuit_chk"
          @parentFuncJoinMember="update_join"
          @parentFuncReloadStock="loadLicenseNoStock"
          @parentFuncSwitchLoading="switchLoading"
        ></AppFormView_1000>
        <AppFormView_1300
          v-else-if="app_type_1300"
          :app_data="application_obj"
          :regist_data="regist_obj"
          :app_check_cd="application_check_cd_obj[1300]"
          :app_check_type="application_check_type_obj"
          :sex_type_cd="sex_type_cd_obj"
          :pref_cd="pref_cd_obj"
          :member_data="member_data_obj"
          :member_document_cd="member_document_cd_obj"
          :circuit_list="circuit_obj"
          :draft_orders="draft_order_obj"
          @parentFuncEditStart="edit_start()"
          @parentFuncEditCancel="edit_cancel()"
          @parentFuncAppUpdate="update"
          @parentFuncAppUpdateCommunication="update_communication"
          @parentFuncCircuitChk="update_circuit_chk"
          @parentFuncUpdateMemberLicense="update_license"
          @parentFuncSwitchLoading="switchLoading"
        ></AppFormView_1300>
        <AppFormView_1400
          v-else-if="app_type_1400"
          :app_data="application_obj"
          :regist_data="regist_obj"
          :app_check_cd="application_check_cd_obj[1400]"
          :app_check_type="application_check_type_obj"
          :sex_type_cd="sex_type_cd_obj"
          :pref_cd="pref_cd_obj"
          :member_document_cd="member_document_cd_obj"
          :circuit_list="circuit_obj"
          :draft_orders="draft_order_obj"
          @parentFuncEditStart="edit_start()"
          @parentFuncEditCancel="edit_cancel()"
          @parentFuncAppUpdate="update"
          @parentFuncAppUpdateCommunication="update_communication"
          @parentFuncCircuitChk="update_circuit_chk"
          @parentFuncJoinMember="update_join"
          @parentFuncSwitchLoading="switchLoading"
        ></AppFormView_1400>
        <div class="w100" v-else-if="app_type_reject">
          <div class="row mb-1 pb-1 border-bottom">
            <div class="alert alert-warning">取り消された申請です</div>
          </div>
        </div>
        <div class="w100" v-else>
          <div class="row mb-1 pb-1 border-bottom">
            <div class="col-2">
              <p class="fs-6 mb-0 pb-0">申請データ</p>
            </div>
          </div>
          <div class="container">
            <div class="row mb-3" v-if="(application_obj || {}).m_id > 0">
              <div class="col-2">
                <p class="text-center py-1 fs-7">会員情報</p>
              </div>
              <div class="col-2">
                <p class="form-control-plaintext">
                  {{ (application_obj || {}).license_no }}
                </p>
              </div>
              <div class="col-2">
                <p class="form-control-plaintext">
                  {{ (application_obj || {}).name_1 }}
                </p>
              </div>
              <div class="col-2">
                <p class="form-control-plaintext">
                  {{ (application_obj || {}).name_2 }}
                </p>
              </div>
            </div>
            <div class="row mb-3" v-else>
              <div class="col-2">
                <p class="text-center py-1 fs-7">会員情報</p>
              </div>
              <div class="col-5">
                <p class="form-control-plaintext">未設定</p>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-2">
                <p class="text-center py-1 fs-7">申請状況</p>
              </div>
              <div class="col-3">
                <bs-select
                  :options="application_check_type_list"
                  :nullOption="false"
                  v-model="application_obj.application_check_type"
                  :disabled="application_obj.application_check_type == 500"
                ></bs-select>
              </div>
              <div class="col-2">
                <p class="fs-6 mb-0 pb-0">申請区分</p>
              </div>
              <div class="col-3">
                <bs-select
                  :options="application_type_list"
                  :nullOption="false"
                  v-model="application_obj.application_type"
                  :disabled="application_obj.application_check_type == 500"
                ></bs-select>
              </div>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-2">
              <p class="text-center py-1 fs-7">申請日</p>
            </div>
            <div class="col-4">
              <input
                type="date"
                class="form-control"
                placeholder="申請日"
                v-model="application_obj.application_date_date"
                :disabled="application_obj.application_check_type == 500"
              />
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-2">
              <p class="text-center py-1 fs-7">承認日</p>
            </div>
            <div class="col-4">
              <div class="input-group">
                <span
                  class="input-group-text"
                  v-if="application_obj.permission_sw"
                  >承認済</span
                >
                <button
                  @click="set_application_permission"
                  type="button"
                  class="btn btn-light btn-outline-secondary"
                  v-else-if="
                    !application_obj.permission_sw &&
                    application_obj.permission_manage_id == 0
                  "
                  :disabled="application_obj.application_check_type == 500"
                >
                  承認する
                </button>
                <input
                  type="date"
                  class="form-control"
                  placeholder=""
                  v-model="application_obj.permission_date_date"
                  disabled="true"
                />
                <button
                  @click="clear_application_permission"
                  type="button"
                  class="btn btn-light btn-outline-secondary"
                  v-if="
                    !application_obj.permission_sw &&
                    application_obj.permission_manage_id != 0
                  "
                  :disabled="application_obj.application_check_type == 500"
                >
                  解除
                </button>
              </div>
            </div>
            <div class="col-3">
              <div class="input-group">
                <span class="input-group-text">承認者</span>
                <input
                  type="text"
                  class="form-control"
                  placeholder=""
                  v-model="application_obj.permission_manage_label"
                  disabled="true"
                />
              </div>
            </div>
          </div>
          <div class="row mb-1 pb-1 border-bottom">
            <div class="col-2">
              <p class="fs-6 mb-0 pb-0">申請内容</p>
              <button
                type="button"
                class="btn btn-light btn-outline-secondary"
                @click="add_item"
              >
                <i class="bi bi-plus"></i>
              </button>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-12">
              <table class="table">
                <thead>
                  <tr>
                    <th style="width: 15%">申請</th>
                    <th style="width: 30%">内容</th>
                    <th style="width: auto">処理</th>
                    <th style="width: 15%">承認者</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in application_obj.items"
                    :key="item"
                  >
                    <td>
                      <input
                        type="hidden"
                        v-model="item.application_key"
                        class="form-control form-control-sm"
                        disabled="disabled"
                      />
                      {{ get_list_application_key_label(item.application_key) }}
                    </td>
                    <td>
                      <!-- 証明書種類の表示の場合 -->
                      <div
                        v-if="
                          item.application_key === 'mfj_outdb_data@path_type'
                        "
                      >
                        <p class="form-control-plaintext">
                          {{ getPathTypeLabel(item.application_value) }}
                        </p>
                      </div>

                      <!-- 証明書（写真）の場合 -->
                      <div v-else-if="item.application_key.includes('path')">
                        <div class="mb-2">
                          <ImageWithZoom
                            v-if="isImage(item.application_value)"
                            :imageSrc="item.application_value"
                            :imageAlt="'証明書画像'"
                            :modalTitle="'証明書画像の詳細表示'"
                            :loading="false"
                            :imageClass="'document-image'"
                            style="max-width: 300px; display: inline-block"
                          />
                          <div
                            v-else-if="item.application_value"
                            class="text-muted"
                          >
                            <a :href="item.application_value" target="_blank"
                              >書類を確認</a
                            >
                          </div>
                          <div
                            v-if="!item.application_value"
                            class="text-muted"
                          >
                            画像なし
                          </div>
                        </div>
                      </div>

                      <!-- 通常のテキスト表示の場合 -->
                      <p v-else class="form-control-plaintext">
                        {{ item.application_value }}
                      </p>
                    </td>
                    <td>
                      <div class="row" v-if="item.message_sw">
                        <div class="col-9">
                          <textarea
                            class="form-control"
                            v-model="item.message"
                          ></textarea>
                        </div>
                        <div class="col-3">
                          <div class="d-grid">
                            <button
                              @click="message_sw_off(index)"
                              type="button"
                              class="btn btn-light btn-outline-secondary"
                              :disabled="
                                application_obj.application_check_type == 500
                              "
                            >
                              解除
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="row" v-else>
                        <div class="col-9">
                          <div class="input-group">
                            <span
                              class="input-group-text"
                              v-if="item.permission_sw"
                              >承認済</span
                            >
                            <button
                              @click="set_item_permission(index)"
                              type="button"
                              class="btn btn-light btn-outline-secondary"
                              v-else-if="
                                !item.permission_sw &&
                                item.permission_manage_id == 0
                              "
                              :disabled="
                                application_obj.application_check_type == 500
                              "
                            >
                              承認する
                            </button>
                            <input
                              type="date"
                              class="form-control"
                              placeholder=""
                              v-model="item.permission_date_date"
                              disabled="true"
                            />
                            <button
                              @click="clear_item_permission(index)"
                              type="button"
                              class="btn btn-light btn-outline-secondary"
                              v-if="
                                !item.permission_sw &&
                                item.permission_manage_id != 0
                              "
                              :disabled="
                                application_obj.application_check_type == 500
                              "
                            >
                              解除
                            </button>
                          </div>
                        </div>
                        <div class="col-3">
                          <div class="d-grid">
                            <button
                              @click="message_sw_on(index)"
                              type="button"
                              class="btn btn-warning"
                              :disabled="
                                application_obj.application_check_type == 500
                              "
                            >
                              不備
                            </button>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control"
                          placeholder=""
                          v-model="item.permission_manage_label"
                          disabled="true"
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="mb-5"></div>
          <div class="row mb-3">
            <div class="col-12 col-sm-2 mb-2">
              <div class="d-grid">
                <button
                  type="submit"
                  @click="back"
                  class="btn btn-light btn-outline-secondary"
                >
                  戻る
                </button>
              </div>
            </div>
            <div
              class="col-12 col-sm-4 offset-sm-2 mb-2 text-center"
              v-if="chk_relation_type_editable('/application/data')"
            >
              <bs-button
                :btnWrapClass="'d-grid'"
                :btnClass="'btn-primary'"
                @to_click_event="update_application()"
                >{{ btnLabel }}</bs-button
              >
            </div>
            <div
              class="col-12 col-sm-4 mb-2"
              v-if="chk_relation_type_editable('/application/data')"
            >
              <div class="d-grid" v-if="validate_items_chk == 600">
                <button
                  type="button"
                  class="btn btn-warning"
                  v-if="send_mail_chk"
                  @click="toggleSendMailChk"
                >
                  <i class="bi bi-check-square"></i>
                  訂正依頼メールを更新時に送る
                </button>
                <button
                  type="button"
                  class="btn btn-light btn-outline-secondary"
                  @click="toggleSendMailChk"
                  v-else
                >
                  <i class="bi bi-square"></i>
                  訂正依頼メールを更新時に送る
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.fs-6 {
  font-size: 1.15rem !important;
}
.fs-7 {
  font-size: 1rem !important;
}
.fs-8 {
  font-size: 0.9rem !important;
}
</style>
<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
import config from '../../../const'
import common from '../../../common/common'
import BsButton from '../../atoms/BsButton.vue'

import AppFormView_1000 from './AppFormView_1000.vue'
import AppFormView_1300 from './AppFormView_1300.vue'
import AppFormView_1400 from './AppFormView_1400.vue'
import ImageWithZoom from '../../molecules/ImageWithZoom.vue'

export default {
  name: 'ApplicationDataView',
  data: function () {
    return {
      targetid: this.$route.params.id,
      fromParentTitle: '',
      fromParentBtn: '',
      alertMessage: '',
      alertClass: 'alert-info',
      btnLabel: '',
      regist_obj: {},
      application_obj: {},
      application_check_type_obj: [],
      application_type_obj: [],
      application_key_obj: [],
      application_check_cd_obj: [],
      search_license_no: '',
      search_member_name_label: '',
      application_check_type: 100,
      item_column: {
        id: 0,
        application_id: 0,
        application_key: '',
        application_value: '',
        permission_date: '',
        permission_sw: false,
        permission_manage_id: '',
        permission_manage_label: ''
      },
      oParam: ['item'],
      sex_type_cd_obj: [],
      pref_cd_obj: [],
      member_document_cd_obj: [],
      circuit_obj: [],
      draft_order_obj: [],
      license_no_stock_obj: [],
      member_data_obj: {},

      app_type_mode: 1000,

      send_mail_chk: false,
      tab_active: 'application',
      gmo_data_obj: '',

      // 管理権限上級者向け設定
      force_update_application_check_type_value: '',
      isLoading: false
    }
  },
  components: {
    BsPageTitle,
    // BsSelect,
    BsMsgAlert,
    BsButton,
    AppFormView_1000,
    AppFormView_1300,
    AppFormView_1400,
    ImageWithZoom
  },
  methods: {
    async switchLoading(sw) {
      if (sw === true) {
        this.isLoading = true
      } else if (sw === false) {
        this.isLoading = false
      } else {
        this.isLoading = false
      }
    },
    async force_update_application_check_type() {
      if (!this.targetid) {
        alert('エラーです')
        return
      }
      const post_url =
        config.BASE_API_URL + '/member_application/edit/' + this.targetid
      const params = {
        application_check_type: this.force_update_application_check_type_value
      }
      let result = true
      await this.basicPosts_I(post_url, params)
        .then(async response => {
          console.log('update member response', response)
          if (
            typeof response === 'object' &&
            response.data &&
            response.data &&
            response.data.status == '200'
          ) {
            this.alertMessage = '更新しました'
            this.alertClass = 'alert-success'
            this.targetid = response.data.body[0].id
          } else if (
            typeof response === 'object' &&
            typeof response.data === 'object' &&
            response.data.status == '500'
          ) {
            console.log(
              'error update status 500',
              response.data.alert.error_obj
            )
            this.alertMessage = '更新できませんでした'
            this.alertClass = 'alert-danger'
            result = false
            if (typeof response.data.alert.error_obj === 'object') {
              const tmp_error = { ...this.member_error_obj }
              Object.keys(response.data.alert.error_obj).forEach(key => {
                tmp_error[key] = response.data.alert.error_obj[key]
              })
              this.member_error_obj = tmp_error
            }
          } else {
            this.alertMessage = '更新できませんでした'
            this.alertClass = 'alert-danger'
            result = false
          }
        })
        .catch(err => {
          console.log(err)
          this.alertMessage = '更新できませんでした'
          this.alertClass = 'alert-danger'
        })
        .finally(async () => {
          if (result) await this.loadApplicationObj()
          this.$forceUpdate()
          // alert(this.alertMessage)
        })
    },
    async getGmoCheck(orderId) {
      if (!orderId) {
        alert('情報が保存されていません。GMOの管理画面で確認してください')
      }
      const params = {
        orderId: orderId
      }
      console.log('loadRaceSeriesList params', params)
      await this.basicPosts_S(config.BASE_API_URL + '/sales/gmo_check', params)
        .then(async response => {
          console.log('getGmoCheck response', response)
          this.gmo_data_obj =
            response.data && response.data.body ? response.data.body : {}
        })
        .catch(async err => {
          console.log(err)
          this.gmo_data_obj = {}
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    toggleSendMailChk() {
      if (this.send_mail_chk) {
        this.send_mail_chk = false
      } else {
        this.send_mail_chk = true
      }
    },
    getPathTypeLabel(value) {
      const pathTypes = {
        10: 'マイナンバーカード',
        20: '運転免許証',
        30: 'パスポート',
        40: '住民票'
      }
      return pathTypes[value] || '未定義'
    },
    // 上部の一括承認処理
    async set_application_permission() {
      // すべてのitemに対して承認情報を設定
      this.application_obj.items.forEach(item => {
        if (!item.permission_on) {
          item.permission_manage_id = this.$store.state.auth.userId
          item.permission_date_date = common.getToday()
          item.permission_manage_label = this.$store.state.auth.label
          item.permission_on = true
        }
      })

      // 上部の承認情報を設定
      this.application_obj.permission_manage_id = this.$store.state.auth.userId
      this.application_obj.permission_date_date = common.getToday()
      this.application_obj.permission_manage_label =
        this.$store.state.auth.label
      this.application_obj.permission_on = true
    },
    async clear_application_permission() {
      this.application_obj.permission_manage_id = 0
      this.application_obj.permission_date_date = ''
      this.application_obj.permission_manage_label = ''
    },
    async set_item_permission(index) {
      // 個別アイテムの承認情報を設定
      this.application_obj.items[index].permission_manage_id =
        this.$store.state.auth.userId
      this.application_obj.items[index].permission_date_date = common.getToday()
      this.application_obj.items[index].permission_manage_label =
        this.$store.state.auth.label
      this.application_obj.items[index].permission_on = true

      // 全アイテムが承認済みかチェック
      const allApproved = this.application_obj.items.every(
        item => item.permission_manage_id > 0
      )

      // 全て承認済みの場合は上部も承認する
      if (allApproved) {
        this.application_obj.permission_manage_id =
          this.$store.state.auth.userId
        this.application_obj.permission_date_date = common.getToday()
        this.application_obj.permission_manage_label =
          this.$store.state.auth.label
        this.application_obj.permission_on = true
      }
    },
    // アイテムの承認解除
    async clear_item_permission(index) {
      this.application_obj.items[index].permission_manage_id = 0
      this.application_obj.items[index].permission_date_date = ''
      this.application_obj.items[index].permission_manage_label = ''
      this.application_obj.items[index].permission_on = false

      // 一つでも未承認があれば上部の承認も解除
      this.application_obj.permission_manage_id = 0
      this.application_obj.permission_date_date = ''
      this.application_obj.permission_manage_label = ''
      this.application_obj.permission_on = false
    },
    async message_sw_on(index) {
      this.clear_item_permission(index)
      this.application_obj.items[index].message_sw = true
    },
    async message_sw_off(index) {
      this.application_obj.items[index].message = ''
      this.application_obj.items[index].message_sw = false
    },
    async edit_start() {
      console.log('edit_start')
      const params = this.application_obj
      if (this.application_obj.application_check_type == 100) {
        this.application_obj.application_check_type = 200
      }
      params['before_edit_manage_id'] = this.application_obj.edit_manage_id
      params['edit_manage_id'] = this.$store.state.auth.userId
      params['edit_date'] = 1
      await this.update(params, 'edit_start')
    },
    async edit_cancel() {
      const params = this.application_obj
      params['before_edit_manage_id'] = this.application_obj.edit_manage_id
      params['edit_manage_id'] = 0

      await this.update(params, 'edit_cancel')
    },
    async loadConfigObj(param) {
      const params = {}
      await this.basicPosts_S(config.BASE_API_URL + '/config/' + param, params)
        .then(async response => {
          // console.log('loadConfigObj response', param, response)
          this[param + '_obj'] =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this[param + '_obj'] = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseNoStock() {
      const params = {}
      params['stat'] = [1]
      params['used_flg'] = 0
      params['pagelimit'] = 20
      await this.basicPosts_S(
        config.BASE_API_URL + '/license_no_stock/lists',
        params
      )
        .then(async response => {
          console.log('loadLicenseNoStock', response)
          this.license_no_stock_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_no_stock_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadSexType() {
      const params = {}
      await this.basicPosts_S(config.BASE_API_URL + '/sex_type/lists', params)
        .then(async response => {
          console.log('loadSexType', response)
          this.sex_type_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.sex_type_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadCircuitList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(config.BASE_API_URL + '/circuit/lists', params)
        .then(async response => {
          console.log('loadCircuitList response', response)
          this.circuit_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.circuit_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadApplicationObj() {
      const params = {}
      params['id'] = this.targetid
      await this.basicPosts_S(
        config.BASE_API_URL + '/member_application/lists',
        params
      )
        .then(async response => {
          console.log('loadApplicationObj', response)
          const tmp_obj =
            response.data && response.data.body && response.data.body[0]
              ? response.data.body[0]
              : {}
          // 上書き
          this.application_obj = tmp_obj
          if ((this.application_obj || {}).regist_id > 0) {
            await this.loadRegistObj((this.application_obj || {}).regist_id)
          }
          if (typeof (this.application_obj || {}).draft_orders === 'object') {
            this.draft_order_obj = (this.application_obj || {}).draft_orders
          }
          // if ((this.application_obj || {}).stat == 9) {
          //   this.app_type_mode = 9999
          // } else
          if ((this.application_obj || {}).application_type == 1300) {
            this.app_type_mode = 1300
          } else if ((this.application_obj || {}).application_type == 1400) {
            this.app_type_mode = 1400
          } else {
            this.app_type_mode = parseInt(
              (this.application_obj || {}).application_type
            )
          }
        })
        .catch(async err => {
          console.log(err)
          this.application_obj = {}
        })
        .finally(async () => {
          if ((this.application_obj || {}).regist_id == 0) {
            await this.switchLoading(false)
          }
          this.$forceUpdate()
        })
    },
    async loadRegistObj(regist_id) {
      const params = {}
      params['id'] = regist_id
      params['mode'] = 'simple'
      await this.basicPosts_S(
        config.BASE_API_URL + '/member_regist/lists',
        params
      )
        .then(async response => {
          console.log('loadRegistObj', response)
          const tmp_obj =
            response.data && response.data.body && response.data.body[0]
              ? response.data.body[0]
              : {}
          // 上書き
          this.regist_obj = tmp_obj
        })
        .catch(async err => {
          console.log(err)
          this.application_obj = {}
        })
        .finally(async () => {
          await this.switchLoading(false)
          this.$forceUpdate()
        })
    },
    async update_license(m_id, c_params) {
      const params = this.application_obj
      params.m_id = m_id
      let type = ''
      // 0円の場合はスルー
      if (c_params?.amount == 0) {
        params.application_check_type = 500
        type = '0yen_license'
      }
      // 決済待ちにする
      else {
        params.application_check_type = 400
        type = 'license'
      }
      await this.update(params, type)
      await this.update_communication(c_params, 'join')
    },
    async update_join(m_id, c_params) {
      const params = this.application_obj
      params.m_id = m_id
      // 決済待ちにする
      params.application_check_type = 400
      await this.update(params, 'join')

      const regist_params = { ...this.regist_obj }
      regist_params.m_id = m_id
      console.log('update_join update_regist regist_params', regist_params)
      await this.update_regist(regist_params)
      await this.update_communication(c_params, 'join')
    },

    async update_circuit_chk(params, type) {
      console.log('=== update_circuit_chk START ===')
      console.log('Params:', params)
      console.log('Type:', type)

      let result = false
      const type_label =
        type == 'correction'
          ? '訂正依頼'
          : type == 'circuit'
          ? '確認依頼'
          : '更新'

      // パラメータの整形
      const formattedParams = {
        ...params,
        edit_date: 1, // 編集日時を設定
        edit_manage_id: this.$store.state.auth.userId, // 編集者ID
        before_manage_id: params.edit_manage_id || 0, // 前回の編集者ID
        // application_date_date を削除（存在しないカラムなので送信しない）
        application_date_date: undefined,
        // application_date のフォーマットを確認
        application_date: params.application_date
          ? params.application_date.split(' ')[0] + ' 00:00:00' // YYYY-MM-DD 00:00:00 形式に
          : new Date().toISOString().split('T')[0] + ' 00:00:00',
        application_check_type: 500
      }

      try {
        const post_url = formattedParams?.id
          ? `${config.BASE_API_URL}/sales_draft_order/circuit_chk/${formattedParams.id}`
          : `${config.BASE_API_URL}/sales_draft_order/add`

        console.log('Sending request with params:', formattedParams)

        const response = await this.basicPosts_I(post_url, formattedParams)

        // レスポンスのログ
        console.log('API Response:', response)
        console.log('Response Data:', response?.data)
        console.log('Response Status:', response?.data?.status)

        // レスポンスの検証
        if (response?.data?.status === 200) {
          console.log('Success: Status 200')
          this.alertMessage = `${type_label}しました`
          this.alertClass = 'alert-success'
          result = true
        } else {
          console.log('Error: Non-200 status')
          console.log('Error details:', response?.data?.alert)
          this.alertMessage = `${type_label}できませんでした`
          this.alertClass = 'alert-danger'
        }
      } catch (error) {
        console.error('Error in update_circuit_chk:', error)
        this.alertMessage = `${type_label}できませんでした`
        this.alertClass = 'alert-danger'
      }

      // 後処理
      console.log('=== Post-processing ===')
      console.log('Result:', result)
      console.log('Type:', type)

      try {
        if (result && type === 'correction') {
          console.log('Executing correction update')
          const obj = { ...this.application_obj }
          obj.application_check_type = 300
          await this.update(obj, type)
        } else if (result) {
          console.log('Loading application object')
          await this.loadApplicationObj()
        }
      } catch (error) {
        console.error('Error in post-processing:', error)
      }

      console.log('=== update_circuit_chk END ===')
      this.$forceUpdate()
      return result
    },
    async update_communication(params, type) {
      let result = false
      const type_label =
        type == 'correction'
          ? '訂正依頼'
          : type == 'circuit'
          ? '確認依頼'
          : '更新'
      params.communication_type = type == 'correction' ? type : false
      const post_url = (params || {}).id
        ? config.BASE_API_URL +
          '/member_application_communication/edit/' +
          (params || {}).id
        : config.BASE_API_URL + '/member_application_communication/add'

      await this.basicPosts_I(post_url, params)
        // console
        //   .log('API Response:', {
        //     url: post_url,
        //     params: params,
        //     response: response,
        //     status: response?.data?.status,
        //     error: response?.data?.alert?.error_obj
        //   })
        .then(async response => {
          console.log('update member response', response)
          if (
            typeof response === 'object' &&
            response.data &&
            response.data &&
            response.data.status == '200'
          ) {
            this.alertMessage = type_label + 'しました'
            this.alertClass = 'alert-success'
            result = true
          } else if (
            typeof response === 'object' &&
            typeof response.data === 'object' &&
            response.data.status == '500'
          ) {
            console.log(
              'error update status 500',
              response.data.alert.error_obj
            )
            this.alertMessage = type_label + 'できませんでした'
            this.alertClass = 'alert-danger'
            result = false
          } else {
            this.alertMessage = type_label + 'できませんでした'
            this.alertClass = 'alert-danger'
            result = false
          }
        })
        .catch(err => {
          console.log(err)
          this.alertMessage = type_label + 'できませんでした'
          this.alertClass = 'alert-danger'
        })
        .finally(async () => {
          // if(result) await this.loadMemberObj();
          if (result && type == 'correction') {
            const obj = this.application_obj
            obj.application_check_type = 600
            await this.update(obj, type)
          } else if (result) {
            await this.loadApplicationObj()
          }
          this.$forceUpdate()
          // alert(this.alertMessage);
        })
    },
    async update_regist(params) {
      console.log('update_regist params', params)
      const post_url = config.BASE_API_URL + '/member_regist/edit/' + params.id

      let result = true
      await this.basicPosts_I(post_url, params)
        .then(async response => {
          console.log('update regist response', response)
          if (
            typeof response === 'object' &&
            response.data &&
            response.data &&
            response.data.status == '200'
          ) {
            result = true
          } else if (
            typeof response === 'object' &&
            typeof response.data === 'object' &&
            response.data.status == '500'
          ) {
            result = false
          } else {
            result = false
          }
        })
        .catch(err => {
          console.log(err)
          result = false
        })
        .finally(async () => {
          if (result) {
            await this.loadRegistObj(params.id)
          }
        })
    },
    validate_items() {},
    async update_application() {
      const params = this.application_obj
      params.application_check_type = 500
      if (this.pass_chg_sw && this.pass_chg_confirm != this.login_pass_input) {
        alert('パスワードが一致しません')
        return true
      } else if (this.pass_chg_sw && this.pass_chg_confirm == '') {
        alert('パスワードを入力して下さい')
        return true
      } else if (
        this.pass_chg_sw &&
        this.pass_chg_confirm == this.login_pass_input
      ) {
        params.login_pass = this.login_pass_input
      }
      // 全アイテムが承認済みかチェック
      // const allApproved = this.application_obj.items.every(
      //   item => item.permission_manage_id > 0
      // )

      // application_check_typeを更新
      params.application_check_type = this.validate_items_chk
      if (params.application_check_type == 500) {
        params.permission_sw = true
      }
      if (this.send_mail_chk) {
        params.send_mail_chk = 1
      } else {
        params.send_mail_chk = 0
      }
      // alert(this.validate_items_chk)
      await this.update(params)
    },
    async update_cancel() {
      const params = this.application_obj
      params['stat'] = 9
      this.update(params, '')
    },
    async update(params, type) {
      const type_label =
        type == 'correction'
          ? '訂正依頼'
          : type == 'join'
          ? '承認'
          : type == 'edit_start'
          ? '対応開始'
          : type == 'edit_cancel'
          ? '対応キャンセル'
          : type == 'save'
          ? '途中保存'
          : type == '0yen_license'
          ? '更新'
          : type == 'license'
          ? '更新'
          : type == 'back'
          ? '巻き戻し'
          : '更新'
      const cancel_flg = params.stat == 9 ? true : false
      const regist_id = params.regist_id > 0 ? params.regist_id : false
      console.log('update component params', params, cancel_flg)
      // console.log('component methods', this.application_obj)
      const post_url =
        this.not_add && type == 'join'
          ? config.BASE_API_URL +
            '/member_application/join_edit/' +
            this.targetid
          : this.not_add && type == '0yen_license'
          ? config.BASE_API_URL +
            '/member_application/join_edit/' +
            this.targetid
          : this.not_add && type == 'license'
          ? config.BASE_API_URL +
            '/member_application/join_edit/' +
            this.targetid
          : this.not_add
          ? config.BASE_API_URL + '/member_application/edit/' + this.targetid
          : config.BASE_API_URL + '/member_application/add'
      params['app_type'] = type
      let result = true
      await this.basicPosts_I(post_url, params)
        .then(async response => {
          console.log('update member response', response)
          if (
            typeof response === 'object' &&
            response.data &&
            response.data &&
            response.data.status == '200'
          ) {
            this.alertMessage = type_label + 'しました'
            this.alertClass = 'alert-success'
            this.targetid = response.data.body[0].id
          } else if (
            typeof response === 'object' &&
            typeof response.data === 'object' &&
            response.data.status == '500'
          ) {
            console.log(
              'error update status 500',
              response.data.alert.error_obj
            )
            this.alertMessage = type_label + 'できませんでした'
            this.alertClass = 'alert-danger'
            result = false
            if (typeof response.data.alert.error_obj === 'object') {
              const tmp_error = { ...this.member_error_obj }
              Object.keys(response.data.alert.error_obj).forEach(key => {
                tmp_error[key] = response.data.alert.error_obj[key]
              })
              this.member_error_obj = tmp_error
            }
          } else {
            this.alertMessage = type_label + 'できませんでした'
            this.alertClass = 'alert-danger'
            result = false
          }
        })
        .catch(err => {
          console.log(err)
          this.alertMessage = type_label + 'できませんでした'
          this.alertClass = 'alert-danger'
        })
        .finally(async () => {
          // if(result) await this.loadMemberObj();
          if (result && cancel_flg && regist_id) {
            console.log('update component finally', result, cancel_flg)
            if (
              typeof this.regist_obj === 'object' &&
              this.regist_obj.id == regist_id
            ) {
              const reg_params = { ...this.regist_obj }
              reg_params.stat = 9
              await this.update_regist(reg_params)
            }
            this.$router.push({ path: '/application/list' })
          }
          if (result) await this.loadApplicationObj()
          this.$forceUpdate()
          await this.switchLoading(false)
          // alert(this.alertMessage)
        })
    },
    // 同一名前、同一誕生日のチェック
    chkMemberObj() {},
    back() {
      this.$router.go(-1)
    },
    tab_switch_action(tab) {
      this.tab_active = tab
    }
  },
  computed: {
    cash_konbini_expiry_date: function () {
      try {
        if (!(this.application_obj || {}).sales?.cash_result) {
          return '-'
        }
        console.log(
          'cash_konbini_expiry_date',
          (this.application_obj || {}).sales?.cash_result
        )
        const cash_result = JSON.parse(
          (this.application_obj || {}).sales?.cash_result
        )
        if (
          !cash_result ||
          !cash_result?.cashResult ||
          !cash_result?.cashResult?.paymentExpiryDateTime
        ) {
          return '--'
        }

        // ISO 8601 形式の日付文字列を Date オブジェクトに変換
        const date = new Date(cash_result?.cashResult?.paymentExpiryDateTime)
        if (isNaN(date.getTime())) return ''

        const pad = num => String(num).padStart(2, '0')
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
          date.getDate()
        )} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
          date.getSeconds()
        )}`
      } catch (e) {
        return '---'
      }
    },
    gmo_data_json: function () {
      return this.gmo_data_obj
    },
    // 特定のアカウントのみ表示
    order_manage_disp: function () {
      if ([1, 2, 4, 27].includes(parseInt(this.$store.state.auth.userId))) {
        return true
      }
      return false
    },
    chk_sales_data_1: function () {
      if (
        (this.application_obj || {}).sales?.charge_result &&
        (this.application_obj || {}).sales?.cash_result
      ) {
        return true
      }
      return false
    },
    chk_sales_data_2: function () {
      if (
        ((this.application_obj || {}).sales?.charge_result ||
          ((this.application_obj || {}).sales?.cash_result &&
            (this.application_obj || {}).sales?.cash_status == 'PAYSUCCESS')) &&
        (this.application_obj || {}).application_check_type < 426
      ) {
        return true
      }
      return false
    },
    chk_sales_data_3: function () {
      return true
    },
    chk_sales_data_4: function () {
      return true
    },
    chk_sales_data_5: function () {
      return true
    },
    chk_sales_data_6: function () {
      return true
    },
    isImage: function () {
      return function (url_path) {
        return /\.(jpg|jpeg|png|gif|bmp|webp|svg|avif)$/i.test(url_path)
      }
    },
    tabDisplay: function () {
      const self_tab_active = this.tab_active
      return function (tab) {
        let tabClass = 'd-none '
        if (self_tab_active == tab) {
          tabClass = 'd-block'
        }
        return tabClass
      }
    },
    tab_switch: function () {
      const self_tab_active = this.tab_active
      return function (tab) {
        let tabClass = 'nav-link '
        // console.log('tab_switch', self_tab_active);
        if (self_tab_active == tab) {
          tabClass += 'active'
        }
        return tabClass
      }
    },
    validate_items_chk: function () {
      // 全アイテムが承認済みかチェック
      const allApproved = this.application_obj.items.every(
        item => item.permission_manage_id > 0
      )
      const chkDef = this.application_obj.items.find(
        item => item.message_sw == true
      )
      return allApproved ? 500 : chkDef ? 600 : 100
    },
    ...mapState({
      // sex_type_list: state => state.apidata.sex_type,
    }),
    license_no_stock_list: function () {
      return this.license_no_stock_obj
    },
    // sex_type_cd_obj: function(){
    //   const tmps = [];
    //   if(
    //     this.sex_type_list === 'object'
    //     && Object.keys(this.sex_type_list).length > 0
    //   ){
    //     Object.values(this.sex_type_list).forEach(sex_type => {
    //       tmps.push({
    //         key: sex_type.key,
    //         label: sex_type.label
    //       })
    //     })}
    //   return tmps;
    // },
    get_list_label: function () {
      return function (key, lists) {
        if (
          key &&
          typeof lists === 'object' &&
          lists.find(list => list.key == key)
        ) {
          return (lists.find(list => list.key == key) || {}).label
        }
        return key
      }
    },
    get_list_application_key_label: function () {
      const application_type = this.application_type_list.find(
        type => type.key == this.application_obj.application_type
      )
        ? this.application_type_list.find(
            type => type.key == this.application_obj.application_type
          ).key
        : false
      const application_key_type =
        typeof this.application_key_list === 'object' &&
        typeof this.application_key_list[application_type] === 'object'
          ? this.application_key_list[application_type]
          : false

      console.log(
        'get_application_key_label application_type',
        application_type
      )
      console.log(
        'get_application_key_label application_key_type',
        application_key_type
      )
      return function (application_key) {
        console.log(
          'get_application_key_label application_key',
          application_key
        )
        if (
          typeof application_key_type === 'object' &&
          application_key_type.find(type => type.key == application_key)
        ) {
          console.log(
            'get_application_key_label application_key_type.find(type => type.key == application_key)',
            application_key_type.find(type => type.key == application_key)
          )
          return application_key_type.find(type => type.key == application_key)
            .label
        }
        return application_key
      }
    },
    application_type_list: function () {
      return this.application_type_obj.filter(
        app_type => parseInt(app_type.key) < 10000
      )
    },
    application_check_type_list: function () {
      return this.application_check_type_obj
    },
    application_key_list: function () {
      return this.application_key_obj
    },

    not_add: function () {
      return this.targetid != 'add' && !Number.isNaN(this.targetid)
        ? true
        : false
    },

    // mode
    app_type_1000: function () {
      return this.app_type_mode == 1000 ? true : false
    },
    app_type_1300: function () {
      return this.app_type_mode == 1300 ? true : false
    },
    app_type_1400: function () {
      return this.app_type_mode == 1400 ? true : false
    },
    app_type_reject: function () {
      return this.app_type_mode == 9999 ? true : false
    }
  },

  async created() {
    await this.switchLoading(true)
    await this.loadConfigObj('application_check_cd')
    await this.loadConfigObj('application_check_type')
    await this.loadConfigObj('application_type')
    await this.loadConfigObj('application_key')
    await this.loadConfigObj('member_document_cd')
    await this.loadConfigObj('sex_type_cd')
    await this.loadConfigObj('pref_cd')
    await this.loadLicenseNoStock()
    await this.loadSexType()
    await this.loadCircuitList()
    // await this.loadConfigObj('application_key.210');

    if (Number.isNaN(this.targetid)) {
      this.$router.push({ path: '/' })
    } else if (this.targetid != 'add' && !Number.isNaN(this.targetid)) {
      await this.loadApplicationObj()
      this.btnLabel = '更新'
    } else {
      this.application_obj = Object.assign({
        id: 0,
        stat: 1,
        m_id: 0,
        application_check_type: '',
        application_type: '',
        application_date: '',
        permission_date_date: '',
        permission_date: '',
        permission_manage_id: '',
        permission_manage_label: '',
        permission_sw: false,
        items: []
      })
      this.btnLabel = '登録'

      // set
      this.oParam.forEach(param => {
        const param_key = param + '_column'
        if (this.application_obj[param] === false) {
          this.application_obj[param] = []
        }
        if (
          typeof this.application_obj[param] !== 'object' ||
          (typeof this.application_obj[param] === 'object' &&
            this.application_obj[param].length <= 0)
        ) {
          this.application_obj[param].push({ ...this[param_key] })
        }
      })
    }
    if (this.application_obj.stat == 9) {
      this.alertMessage = '取り消された申請です。'
    } else {
      this.alertMessage = this.btnLabel + 'できます'
    }

    if (
      this.app_type_1000 == false &&
      this.app_type_1300 == false &&
      this.app_type_1400 == false
    ) {
      await this.switchLoading(false)
    }
    this.$forceUpdate()
  },
  mounted: function () {
    this.fromParentTitle = '申請データ'
  },
  props: {}
}
</script>
